<template>
  <div class="zp-type-nav">
    <img v-lazy="require('@/assets/index/zpTypeNav/社招岗位@2x.png')" @click="$router.push('list?attributes=1')">
    <img v-lazy="require('@/assets/index/zpTypeNav/校招岗位@2x.png')" @click="$router.push('list?attributes=0')">
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.zp-type-nav {
  width: 100%;
  padding: 54px 0 67px;
  background-color: #fff;
  img {
    display: block;
    width: auto;
    height: 91px;
    margin: 0 auto;
    &:first-child {
      margin-bottom: 11px;
    }
  }
}
</style>
